import { useContext } from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, Route, Routes, useNavigate } from "react-router-dom";
import LogoutPage from './layouts/nav/Logout';
/// Css
import "./chart.css";
import "./index.css";
import "./step.css";

/// Layout
import Footer from "./layouts/Footer";
import Nav from "./layouts/nav";
import Nav2 from "./layouts/nav/index2";
import ScrollToTop from "./layouts/ScrollToTop";
// import Main from './layouts/Main';
import WalletBar from './layouts/WalletBar';
/// Dashboard

//student
/* import StudentDetails from "./components/Student/StudentDetails"; */

//Teacher
//Food

/// File Manager
import FileChat from './components/FileManager/FileChat';
import FileManager from './components/FileManager/FileManager';



/// App
import Compose from "./components/AppsMenu/Email/Compose/Compose";
import Inbox from "./components/AppsMenu/Email/Inbox/Inbox";
import Read from "./components/AppsMenu/Email/Read/Read";

/// Product List

/// Charts

/// Bootstrap

/// Plugins
// import MainNouiSlider from "./components/PluginsMenu/NouiSlider/MainNouiSlider";
// import JqvMap from "./components/PluginsMenu/JqvMap/JqvMap";


/// Widget

/// Table

/// Form
// import CkEditor from "./components/Forms/CkEditor/CkEditor";

/// Pages

import { ThemeContext } from "../context/ThemeContext";
import BatchManagement from "./components/Batch-Management/BatchManagement";
import QuestionBank from "./components/QuestionBank/QuestionBank";
import AddTest from "./components/TestManagement/AddNewTest";
import TestManagement from "./components/TestManagement/TestManagement";
import Error400 from "./pages/Error400";
import Error403 from "./pages/Error403";
import Error404 from "./pages/Error404";
import Error500 from "./pages/Error500";
import Error503 from "./pages/Error503";
import LockScreen from "./pages/LockScreen";
// import AddComprehension from "./components/Comprehension/AddComprehension";
import { useRole } from "../context/UserRoleContext";
import AdminDashboard from "./components/AdminDashboard/AdminDashboard";
import Blogs from "./components/Blogs/Blogs";
import BookLessons from "./components/Books/BookLessons/BookLesson";
import BookLessonQuestions from "./components/Books/BookLessons/BookLessonQuestions";
import BookQuestionBank from "./components/Books/BookQuestionBank";
import Books from "./components/Books/Books";
import BookSubjects from "./components/Books/BookSubjects";
import PracticeTests from "./components/Books/PracticeTests";
import CopyQuestions from "./components/CopyQuestions/CopyQuestions";
import CourseGrid from "./components/Course/CourseGrid";
import Subject from "./components/Course/Subject";
import TopicDetails from "./components/Course/TopicDetails/TopicDetails";
import TopicQuestionBank from "./components/Course/TopicDetails/TopicQuestionBank";
import TopicReports from "./components/Course/TopicDetails/TopicReports";
import TopicStartDate from "./components/Course/TopicDetails/TopicStartDate";
import CUET_QuestionBank from "./components/CUET/CUET_QuestionBank";
import CUET_Resources from "./components/CUET/CUET_Resources";
import CUET_Sections from "./components/CUET/CUET_Sections";
import CUET_Settings from "./components/CUET/CUET_Settings";
import CUET_Subjects from "./components/CUET/CUET_Subjects";
import CUET_TestManagement from "./components/CUET/CUET_TestManagement";
import CUET_TestPricings from "./components/CUET/CUET_TestPricings";
import CurrentAffairs from "./components/CurrentAffairs/CurrentAffairs";
import DummyPage from "./components/DummyPage";
import IGPClasses from "./components/IGP/IGPClasses";
import IGPDownloads from "./components/IGP/IGPDownloads";
import IGPSessions from "./components/IGP/IGPSessions";
import IGPStudents from "./components/IGP/IGPStudents";
import EditMyProfile from "./components/MyAccount/EditMyProfile";
import MyAccount from "./components/MyAccount/MyAccount";
import NEET_QuestionBank from "./components/NEET/NEET_QuestionBank";
import NEET_Resources from "./components/NEET/NEET_Resources";
import NEET_Sections from "./components/NEET/NEET_Sections";
import NEET_Settings from "./components/NEET/NEET_Settings";
import NeetSubject from "./components/NEET/NEET_Subjects";
import NEET_TestManagement from "./components/NEET/NEET_TestManagement";
import NEET_TestPricings from "./components/NEET/NEET_TestPricings";
import NEET_Topics from "./components/NEET/NEET_Topics";
import Notifications from "./components/Notifications/Notifications";
import About from "./components/Operational-Setting/About";
import AcademicYear from "./components/Operational-Setting/AcademicYear";
import BlogCategory from "./components/Operational-Setting/BlogCategory";
import CourseType from "./components/Operational-Setting/CourseType";
import ExamBody from "./components/Operational-Setting/ExamBody";
import Faculty from "./components/Operational-Setting/Faculty";
import ImpWebsite from "./components/Operational-Setting/ImpWebsite";
import NewsCategory from "./components/Operational-Setting/NewsCategory";
import NewsTags from "./components/Operational-Setting/NewsTags";
import Testimonials from "./components/Operational-Setting/Testimonials";
import VirtualDevice from "./components/Operational-Setting/VirtualDevice";
import ArticleTypes from "./components/Operational-Setting/ArticleTypes";
import SocialLinks from "./components/Operational-Setting/SocialLinks";
import OrderManagement from "./components/Order/OrderManagement";
import QuizQuestionBank from "./components/QuizDetails/QuizQuestionBank";
import QuizSections from "./components/QuizDetails/QuizSections";
import QuizSubjects from "./components/QuizDetails/QuizSubjects";
import StaffDetails from "./components/StaffDetails/StaffDetails";
import StaffManagement from "./components/StaffManagement/StaffManagement";
import Enrollment from "./components/StudentComponents/Enrollment/Enrollment";
import Reports from "./components/StudentComponents/Report/Reports";
import TestReport from "./components/StudentComponents/Report/TestReport";
import StartTest from "./components/StudentComponents/StartTest/StartTest";
import EditStudentProfile from "./components/StudentComponents/StudentAccount/EditStudentProfile";
import StudentAccount from "./components/StudentComponents/StudentAccount/StudentAccount";
import StudentDashboard from "./components/StudentComponents/StudentDashboard/StudentDashbooard";
import StudentNotifications from "./components/StudentComponents/StudentNotifications/StudentNotifications";
import TestSeries from "./components/StudentComponents/TestSeries/TestSeries";
import AddStudent from "./components/StudentDetails/AddStudent";
import StudentManagement from "./components/StudentDetails/StudenManagement";
import Subscribers from "./components/StudentDetails/Subscribers";
import TestSeriesSubscribers from "./components/StudentDetails/TestSeriesSubscribers";
import TeacherSupport from "./components/teacherSupport/TeacherSupport";
import ModerateSolution from "./components/TestManagement/SubTestSeries/ModerateSolution";
import PendingMains from "./components/TestManagement/SubTestSeries/PendingMains";
import TestLists from "./components/TestManagement/SubTestSeries/TestLists";
import TestReports from "./components/TestManagement/TestReports";
import TestResults from "./components/TestManagement/TestResults";
import UGC_QuestionBank from "./components/UGC_NET/UGC_QuestionBank";
import UGC_Sections from "./components/UGC_NET/UGC_Sections";
import UGC_Settings from "./components/UGC_NET/UGC_Settings";
import UGC_AllSubjects from "./components/UGC_NET/UGC_AllSubjects";
import UGC_TestManagement from "./components/UGC_NET/UGC_TestManagement";
import UGC_TestPricings from "./components/UGC_NET/UGC_TestPricing";
import UGC_Topics from "./components/UGC_NET/UGC_Topics";
import WebsiteQuery from "./components/websitequery/WebsiteQuery";
import UsersActivities from "./components/websiteUsers/UsersActivities";
import Visitors from "./components/websiteUsers/Visitors";
import Login from "./pages/Login";
import UGC_Resources from "./components/UGC_NET/UGC_Resources";
import UGC_Subscribers from "./components/UGC_NET/UGC_Subscribers";
import UGC_Abouts from "./components/UGC_NET/UGC_Abouts";
import UGC_Articles from "./components/UGC_NET/UGC_Articles";
import CUET_Topics from "./components/CUET/CUET_Topics";
import CUET_Subscribers from "./components/CUET/CUET_Subscribers";
import NEET_Subscribers from "./components/NEET/NEET_Subscribers";
import CUET_Abouts from "./components/CUET/CUET_Abouts";
import CUET_Articles from "./components/CUET/CUET_Articles";
import PracticeTestBanners from "./components/CUET/PracticeTestBanners";
import LiveStreaming from "./components/live_streaming/LiveStreaming";
import CUET_AllSubjects from "./components/CUET/CUET_AllSubjects";
import CUET_CourseRecommendations from "./components/CUET/CUET_CourseRecommendations";
import NEET_Articles from "./components/NEET/NEET_Articles";
import NEET_Abouts from "./components/NEET/NEET_Abouts";
import NEET_CourseRecommendations from "./components/NEET/NEET_CourseRecommendations";
import NEET_PracticeTestBanners from "./components/NEET/NEET_PracticeTestBanners";
import NEET_AllSubjects from "./components/NEET/NEET_AllSubjects";
import UGC_CourseRecommendations from "./components/UGC_NET/UGC_CourseRecommendations";
import UGC_PracticeTestBanners from "./components/UGC_NET/UGC_PracticeTestBanners";
//import Finance from "./components/Dashboard/Finance";
const Markup = () => {
  const [userRole, setUserRole] = useRole();
  const tokenDetailsString = localStorage.getItem('userDetails');
  const userRoleInLocalStorage = JSON.parse(tokenDetailsString).userRole
  // console.log(userRole, userRoleInLocalStorage)
  const navigate = useNavigate()
  /*   useEffect(() => {
      if (userRoleInLocalStorage == 2) {
        navigate('/student/dashboard')
      } else if (userRoleInLocalStorage == 1) {
        navigate('/dashboard')
      }
    }, []) */
  const routhPath = [
    { url: "dashboard", component: <AdminDashboard /> },
    { url: "live-streaming", component: <LiveStreaming /> },
    //operational setting routes
    { url: "about", component: < About /> },
    { url: "academic-year", component: < AcademicYear /> },
    { url: "exam-body", component: < ExamBody /> },
    { url: "module-type", component: < CourseType /> },
    { url: "news-category", component: < NewsCategory /> },
    { url: "blog-category", component: < BlogCategory /> },
    { url: "news-tags", component: < NewsTags /> },
    { url: "faculty", component: < Faculty /> },
    { url: "dumy", component: < DummyPage /> },
    { url: "testimonials", component: < Testimonials /> },
    { url: "imp-websites", component: < ImpWebsite /> },
    { url: "allow-virtual-device", component: < VirtualDevice /> },
    { url: "article-types", component: < ArticleTypes /> },
    { url: "cuet-article-types", component: < ArticleTypes /> },
    { url: "neet-article-types", component: < ArticleTypes /> },
    { url: "ugc-net-article-types", component: < ArticleTypes /> },
    { url: "social-links", component: < SocialLinks /> },

    { url: "course-management", component: <CourseGrid /> },
    { url: "subject-details", component: <Subject /> },
    { url: "lesson-details", component: <TopicDetails /> },
    { url: "lesson-dates", component: <TopicStartDate /> },
    { url: "lesson-reports", component: <TopicReports /> },
    // { url: "classes", component: <AddClasses /> },
    { url: "batch-management", component: <BatchManagement /> },
    { url: "test-series", component: <TestManagement /> },
    { url: "books", component: <Books /> },
    { url: "book-sections", component: <BookSubjects /> },
    { url: "books-lessons", component: <BookLessons /> },
    { url: "practice-tests", component: <PracticeTests /> },
    { url: "test-reports", component: <TestReports /> },
    { url: "pending-mains", component: <PendingMains /> },
    { url: "copy-questions", component: <CopyQuestions /> },
    { url: "moderate-solution", component: <ModerateSolution /> },
    { url: "test-lists", component: <TestLists /> },
    { url: "add-test", component: <AddTest /> },
    { url: "edit-test/:id", component: <AddTest /> },
    { url: "test-results", component: <TestResults /> },
    { url: "orders/:orderType", component: <OrderManagement /> },
    { url: "igp-students", component: <IGPStudents /> },
    { url: "igp-downloads", component: <IGPDownloads /> },
    { url: "igp-sessions", component: <IGPSessions /> },
    { url: "igp-classes", component: <IGPClasses /> },
    // { url: "testseries-orders", component: <OrderManagement /> },
    { url: "teacher-support", component: <TeacherSupport /> },
    { url: "website-query", component: <WebsiteQuery /> },
    { url: "users-activities", component: <UsersActivities /> },
    { url: "visitors", component: <Visitors /> },
    // { url: "new-activities", component: <NewActivities /> },

    //quiz routes
    { url: "quiz-subjects", component: <QuizSubjects /> },
    { url: "quiz-sections", component: <QuizSections /> },
    //cuet routes
    { url: "cuet-abouts", component: <CUET_Abouts /> },
    { url: "cuet/all-subjects", component: <CUET_AllSubjects /> },
    { url: "cuet-sections", component: <CUET_Sections /> },
    { url: "cuet-settings", component: <CUET_Settings /> },
    { url: "cuet-pricings", component: <CUET_TestPricings /> },
    { url: "cuet-resources", component: <CUET_Resources /> },
    { url: "cuet/topics", component: <CUET_Topics /> },
    { url: "cuet-subscribers", component: <CUET_Subscribers /> },
    { url: "cuet/tests-management", component: <CUET_TestManagement /> },
    { url: "cuet-articles", component: <CUET_Articles /> },
    { url: "cuet-practice-test-banners", component: <PracticeTestBanners /> },
    { url: "cuet-course-recommendations", component: <CUET_CourseRecommendations /> },

    //ugc routes
    { url: "ugc-home", component: <UGC_Abouts /> },
    { url: "ugc/all-subjects", component: <UGC_AllSubjects /> },
    { url: "ugc-sections", component: <UGC_Sections /> },
    { url: "ugc-topics", component: <UGC_Topics /> },
    { url: "ugc-pricings", component: <UGC_TestPricings /> },
    { url: "ugc-resources", component: <UGC_Resources /> },
    { url: "ugc-settings", component: <UGC_Settings /> },
    { url: "ugc/tests-management", component: <UGC_TestManagement /> },
    { url: "ugc-subscribers", component: <UGC_Subscribers /> },
    { url: "ugc-articles", component: <UGC_Articles /> },
    { url: "ugc-course-recommendations", component: <UGC_CourseRecommendations /> },
    { url: "ugc-practice-test-banners", component: <UGC_PracticeTestBanners /> },

    //NEET routes
    { url: "neet-subjects", component: <NeetSubject /> },
    { url: "neet/all-subjects", component: <NEET_AllSubjects /> },
    { url: "neet-sections", component: <NEET_Sections /> },
    { url: "neet-pricings", component: <NEET_TestPricings /> },
    { url: "neet-test-settings", component: <NEET_Settings /> },
    { url: "neet-topics", component: <NEET_Topics /> },
    { url: "neet-resources", component: <NEET_Resources /> },
    { url: "neet-subscribers", component: <NEET_Subscribers /> },
    { url: "neet/tests-management", component: <NEET_TestManagement /> },
    { url: "neet-articles", component: <NEET_Articles /> },
    { url: "neet-home", component: <NEET_Abouts /> },
    { url: "neet-course-recommendations", component: <NEET_CourseRecommendations /> },
    { url: "neet-practice-test-banners", component: <NEET_PracticeTestBanners /> },




    // { url: "add-comprehension", component: <AddComprehension /> },
    // { url: "edit-comprehension/:id", component: <AddComprehension /> },
    { url: "student-management", component: <StudentManagement /> },
    { url: "staff-management", component: <StaffManagement /> },
    { url: "subscribers", component: <Subscribers /> },
    { url: "testseries-subscribers", component: <TestSeriesSubscribers /> },
    { url: "current-affairs", component: <CurrentAffairs /> },
    { url: "blogs", component: <Blogs /> },
    { url: "add-student", component: < AddStudent /> },
    { url: "edit-student/:id", component: < AddStudent /> },
    { url: "notifications", component: <Notifications /> },
    { url: "my-account", component: <MyAccount /> },
    { url: "staff-details", component: < StaffDetails /> },
    { url: "edit-profile", component: < EditMyProfile /> },
    { url: "logout", component: < LogoutPage logout="logot" /> },
  ]
  const routhPath2 = [
    //student pages
    { url: 'student/dashboard', component: <StudentDashboard /> },
    { url: 'student/enrollment', component: <Enrollment /> },
    { url: 'student/test-series', component: <TestSeries /> },
    { url: 'student/reports', component: <Reports /> },
    { url: 'student/test-report', component: <TestReport /> },
    { url: 'student/notifications', component: <StudentNotifications /> },
    { url: 'student/my-account', component: <StudentAccount /> },
    { url: 'student/edit-profile', component: <EditStudentProfile /> },
    { url: "student/logout", component: < LogoutPage logout="logot" /> },
  ];
  return (
    <>
      <Routes>
        <Route path='/page-error-400' element={<Error400 />} />
        <Route path='/page-error-403' element={<Error403 userRole={userRole} userRoleInLocalStorage={userRoleInLocalStorage} />} />
        <Route path='/page-error-404' element={<Error404 />} />
        <Route path='/page-error-500' element={<Error500 />} />
        <Route path='/page-error-503' element={<Error503 />} />
        <Route path='/page-lock-screen' element={<LockScreen />} />
        {/*  <Route element={<Layout1 />}>
          <Route path='/' exact element={<Home />} />
          <Route path='/dashboard' exact element={<Home />} />
          <Route path='/dashboard-dark' exact element={<DashboardDark />} />
        </Route> */}
        <Route element={<Layout2 />}>
          {routhPath.map((data, i) => (
            <Route key={i} exact path={`/${data.url}`} element={data.component} />
          ))}
        </Route>
        <Route element={<Layout6 userRole={userRole} userRoleInLocalStorage={userRoleInLocalStorage} />}>
          {routhPath2.map((data, i) => (
            <Route key={i} exact path={`/${data.url}`} element={data.component} />
          ))}
        </Route>
        <Route element={<Layout5 userRole={userRole} userRoleInLocalStorage={userRoleInLocalStorage} />}>
          <Route path='/file-manager' exact element={<FileManager />} />
          <Route path='/chat' exact element={<FileChat />} />
          <Route path='/email-compose' exact element={<Compose />} />
          <Route path='/email-inbox' exact element={<Inbox />} />
          <Route path='/email-read' exact element={<Read />} />
          {/* <Route path='/test-series/test/question-bank' exact element={<QuestionBank />} /> */}
          <Route path='/test-series/test/question-bank' exact element={<QuestionBank />} />
          <Route path='/quiz-questions' exact element={<QuizQuestionBank />} />
          <Route path='/cuet-questions' exact element={<CUET_QuestionBank />} />
          <Route path='/ugc-questions' exact element={<UGC_QuestionBank />} />
          <Route path='/neet-questions' exact element={<NEET_QuestionBank />} />
          <Route path='/topic-question-bank' exact element={<TopicQuestionBank />} />
          <Route path='/book-questions' exact element={<BookQuestionBank />} />
          <Route path='/book-lesson-questions' exact element={<BookLessonQuestions />} />
        </Route>
        <Route element={<Layout7 userRole={userRole} userRoleInLocalStorage={userRoleInLocalStorage} />}>
          <Route path='/student/start-test' exact element={<StartTest />} />,
        </Route>
        <Route path='/login' element={<Login />} />
        <Route path='/' element={<Navigate to={userRole == 1 && userRoleInLocalStorage == 1 ? '/dashboard' : '/student/dashboard'} />} />
        <Route path='*' element={<Error404 userRole={userRole} userRoleInLocalStorage={userRoleInLocalStorage} />} />
      </Routes>
      <ScrollToTop />
    </>
  );
};

function Layout1() {
  const { sidebariconHover } = useContext(ThemeContext);
  const sideMenu = useSelector(state => state.sideMenu);
  let windowsize = window.innerWidth;
  // console.log(windowsize, 'size')
  return (

    <div id="main-wrapper" className={` show  ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
      <div className={`wallet-open  ${windowsize > 1199 ? 'active' : ''}`}>
        <Nav2 />
        <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
          <div className="container-fluid">
            <Outlet />
          </div>
        </div>
        <Footer changeFooter="footer-outer" />
        <WalletBar />
      </div>
    </div>

  )
}

function Layout2(props) {
  const navigate = useNavigate();
  const sideMenu = useSelector(state => state.sideMenu);
  const { sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height + 20 }}>
        <div className="container-fluid">
          <Outlet />
        </div>
      </div>
      <Footer changeFooter="out-footer style-2" />
    </div>

  )
}
function Layout6(props) {
  const navigate = useNavigate();
  const sideMenu = useSelector(state => state.sideMenu);
  const { sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body" style={{ minHeight: window.screen.height + 20 }} >
        <div className="container-fluid">
          {(props.userRoleInLocalStorage == props.userRole) && (props.userRoleInLocalStorage == 2) ? <Outlet /> : navigate('/page-error-403')}
        </div>
      </div>
      <Footer changeFooter="out-footer style-2" />  {/* original-style: style-1 */}
    </div>
  )
}



function Layout5(props) {
  const navigate = useNavigate();
  const sideMenu = useSelector(state => state.sideMenu);
  const { sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body message-body mh-auto">
        <div className="container-fluid mh-auto p-0">
          {(props.userRoleInLocalStorage == props.userRole) && (props.userRoleInLocalStorage == 1) ? <Outlet /> : navigate('/page-error-403')}
        </div>
      </div>
    </div>
  )
}
function Layout7(props) {
  const navigate = useNavigate();
  const sideMenu = useSelector(state => state.sideMenu);
  const { sidebariconHover } = useContext(ThemeContext);
  return (
    <div id="main-wrapper" className={`show ${sidebariconHover ? "iconhover-toggle" : ""} ${sideMenu ? "menu-toggle" : ""}`}>
      <Nav />
      <div className="content-body message-body mh-auto">
        <div className="container-fluid mh-auto p-0">
          {(props.userRoleInLocalStorage == props.userRole) && (props.userRoleInLocalStorage == 2) ? <Outlet /> : navigate('/page-error-403')}
        </div>
      </div>
    </div>
  )
}


export default Markup;